var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu6dt0e05a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333.664C.597.664 0 1.261 0 1.997v12c0 .737.597 1.334 1.333 1.334h3.334c.736 0 1.333-.597 1.333-1.334v-12C6 1.261 5.403.664 4.667.664H1.333zm0 1.333h3.334v12H1.333v-12zM8.667.664c-.737 0-1.334.597-1.334 1.333v12c0 .737.597 1.334 1.334 1.334V1.997H12v2.667a.667.667 0 0 0 1.333 0V1.997c0-.736-.597-1.333-1.333-1.333H8.667zM10 13.997c0-.368.299-.666.667-.666h4a.667.667 0 0 1 0 1.333h-4a.667.667 0 0 1-.667-.667zm3.333-6.666a.667.667 0 1 0-1.333 0v1.333h-1.333a.667.667 0 1 0 0 1.333H12v1.334a.667.667 0 0 0 1.333 0V9.997h1.334a.667.667 0 0 0 0-1.333h-1.334V7.331z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bu6dt0e05a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListColumn);
export default __webpack_public_path__ + "static/media/listColumn.66eb9b1fcafaef7950c9a57143d8cb07.svg";
export { ForwardRef as ReactComponent };